import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/react';

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
            const graphError = `[GraphQL error]: Message: ${message}\nPath: ${JSON.stringify(path)}\nLocation: ${JSON.stringify(locations)}`;
            // * uncomment if you want to debug graphql api
            // console.error(graphError);

            Sentry.captureException(graphError);
        });
    }

    if (networkError) {
        const networkErrorMsg = `[Network error]: ${networkError}`;
        // * uncomment if you want to debug graphql api
        // console.error(networkErrorMsg);

        Sentry.captureException(networkErrorMsg);
    }
});

export default errorLink;
